import { render } from "./Quiz.vue?vue&type=template&id=a3119afe&scoped=true"
import script from "./Quiz.vue?vue&type=script&lang=js"
export * from "./Quiz.vue?vue&type=script&lang=js"

import "./Quiz.vue?vue&type=style&index=0&id=a3119afe&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3119afe"]])

export default __exports__